// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"NV-z","sponsoredTooltipWrapper":"OV-z","sponsoredTooltip":"PV-z","newCard":"QV-z"};